/**
 * A code visit, handed from /remote (where the code was typed) to the
 * controller page in memory only: never in the URL, history or storage.
 * A reload loses it, which is fine: the code was single use anyway (the
 * page then says to ask for a new one).
 */
export interface CodeVisit {
  roomId: string;
  lobbyKey: string;
  deviceType?: string;
}

let current: CodeVisit | null = null;

export function setCodeVisit(v: CodeVisit | null): void {
  current = v;
}

export function codeVisit(): CodeVisit | null {
  return current;
}
